import isEmpty from './isEmpty.js'
import hasTempId from './hasTempId.js'
//----------------------
// strip array temp ids
//----------------------
export default function stripArrayTempIds(array) {
  if (!isEmpty(array)) {
    array.forEach((el) => {
      if (hasTempId(el.id)) {
        delete el.id
      }
    })
  }
  return array
}
